import { render, staticRenderFns } from "./56.vue?vue&type=template&id=8551e63e&scoped=true&"
import script from "./56.vue?vue&type=script&lang=js&"
export * from "./56.vue?vue&type=script&lang=js&"
import style0 from "./56.vue?vue&type=style&index=0&id=8551e63e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8551e63e",
  null
  
)

export default component.exports